import { IWaitlistStatus } from '../../../interfaces/scheduler_interfaces';
import { ITermCourse, ISectionType, ISectionLabel } from '../../../interfaces/scheduler_interfaces';
import { ISectionTime, IRawSection } from '../../../interfaces/scheduler_interfaces';
import { ISection, ICampus, ISectionAvailability } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
export class Section implements ISection {
  static build(section: IRawSection) {
    return new Section(section);
  }
  id: number;
  nk: string;
  cd: string;
  course: number;
  campus: number;
  section_type: number;
  seats_offered: number;
  instructor_name: string;
  class_start_dt: string;
  class_end_dt: string;
  drop_start_dt: string;
  drop_end_dt: string;
  withdraw_end_dt: string;
  can_withdraw: boolean;
  is_unlimited_seating: boolean;
  note: string;
  status: string;
  has_waitlist: boolean;
  is_droppable?: boolean;
  is_selected?: boolean;
  is_repeatable: boolean = false;
  session: number = -1;
  title: string;

  _section_times: ISectionTime[];
  _course: ITermCourse;
  _campus: ICampus;
  _section_type: ISectionType;
  _availability: ISectionAvailability;
  _linked_sections: number[];
  _isEligibleForRegistration?: boolean;
  _section_labels: ISectionLabel;
  _section_status?: IWaitlistStatus;

  constructor(section: IRawSection) {
    _4.merge(this, section, { status: section.status || '', session: section.session || -1 });
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/sections/builders/section_builder.ts